import Footer from "./Footer";
import SiteTerms from "./SiteTerms";
//import StoreTerms from "./StoreTerms";
import { useEffect } from "react";

  
export default function LegalNotices() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    return (
      <>
      
      <div id="help-resources" className='mx-auto max-w-6xl px-6 py-24 sm:py-15 lg:py-20 lg:px-8'>
        <h1 className='text-2xl font-bold leading-10 tracking-tight text-gray-900'>Legal Notices</h1>
      <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow my-8">
      
        {/*actions.map((action, actionIdx) => (
          <div key={action.title}
            className={classNames(
              //actionIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '',
              actionIdx === actions.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '',
              'group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500',
            )}
          >
            <div className="mt-8">
              <h3 className="text-base font-semibold text-gray-900">
                <a href={action.href} className="flex w-full items-start justify-between text-left text-gray-900 hover:text-blue-700 transition">
                  
                  <span aria-hidden="true" className="absolute inset-0" />
                  {action.title} <ArrowUpRightIcon className="h-6 w-6 text-gray-600 inline" aria-hidden="true" />
                </a> 
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                {action.content}
              </p>
            </div>
            {action.contentArray && (
              <div className="mt-4">
                {action.contentArray.map((content, contentIdx) => (
                  <p key={contentIdx} className="mt-2 text-sm text-gray-500">
                    {content}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))*/}
        <div className="group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
          <div className="mt-4">
            <h3 className="text-2xl font-semibold text-gray-900">
                Site Terms of Use 
            </h3>
            <p className="mt-2 text-sm text-gray-500">
              (Last updated: May 30, 2025)
            </p>
            <SiteTerms />
          </div>
        </div>

        {/* STORE TERMS AND CONDITIONS
        <div className="group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
          <div className="mt-8">
            <h3 className="text-2xl font-semibold text-gray-900">
                Store Terms &amp; Conditions
            </h3>
            <p className="mt-2 text-sm text-gray-500">
              (Last updated: May 20, 2025)
            </p>
            <StoreTerms />
          </div>
        </div>*/}

        {/*<div className="group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 hidden">
          <div className="mt-8">
            <h3 className="text-base font-semibold text-gray-900">
              <p className="flex w-full items-start justify-between text-left text-gray-900">
                <span aria-hidden="true" className="absolute inset-0" />
                Copyright and Trademark
              </p>
            </h3>
            <p className="mt-2 text-sm text-gray-500">
              This is a Website of the University Corporation for Atmospheric Research (UCAR).
            </p>
            <p className="mt-2 text-sm text-gray-500">
              References therein to other Web pages, which may be linked to this Website, specific commercial products, processes, or services by trade name, trademark, manufacturer, or otherwise do not constitute or imply an endorsement, recommendation, or favoring by UCAR. The user of this Website understands that, with the exception of an employee or other authorized user of a UCAR sponsoring organization, UCAR may not be obligated to provide any support, consulting, training, or assistance of any kind with regard to the use of this Website, or to provide any updates, revisions, or new versions.
            </p>
            <p className="mt-2 text-sm text-gray-500">
              COMET® is a registered trademark of UCAR.
            </p>
            <p className="mt-2 text-sm text-gray-500">
              ©1997-{currentYear}, University Corporation for Atmospheric Research. All Rights Reserved.
            </p>
          </div>
        </div>

        <div className="group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 hidden">
          <div className="mt-8">
            <h3 className="text-base font-semibold text-gray-900">
              <p className="flex w-full items-start justify-between text-left text-gray-900">
                <span aria-hidden="true" className="absolute inset-0" />
                COMET Terms of Use
              </p>
            </h3>
            <p className="mt-2 text-sm text-gray-500">
              ©1997-{currentYear}, University Corporation for Atmospheric Research. All Rights Reserved.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            This Website was developed by the COMET® Program of the University Corporation for Atmospheric Research (UCAR), sponsored in part through cooperative agreement(s) with the National Oceanic and Atmospheric Administration (NOAA), U.S. Department of Commerce (DOC). The views expressed in this Website are those of the authors and do not necessarily reflect the view of DOC, any of its subagencies, or any other Sponsors of COMET and/or UCAR.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            Throughout this Site, you can access images, information, documents, software, data, models and services (collectively, the "Materials"). Your use of the Materials is subject to these Terms of Use. Most of the Materials have been developed by COMET, but some of the Materials are provided by COMET, with permission from third parties ("Third Party Materials"). Your use of such Third Party Materials may be limited by additional terms of use required by the Third Party (the "Additional Terms"). COMET routinely includes applicable Third Party credit and/or copyright notices next to the image itself and related terms of use, if any, in a closely associated bibliography or image gallery. In the absence of specific terms of use, only these Terms of Use shall apply. The burden of determining whether use of any Material on or linked to a Site is permissible, rests with you, the user.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            Subject to these Terms of Use and any Additional Terms imposed by a Third Party, the user is granted the right, without any fee or cost, to access, link to and use, publish, distribute, disseminate, transfer, or in any manner alter, modify, revise, crop, copy (an unlimited number of times), edit, digitize, and authorize such uses for third parties for any non-profit training, research, or educational purpose whatsoever and not for any direct or indirect commercial purpose or advantage. The content in this Website must not in any manner be misrepresented. The user must include an appropriate citation crediting the source of all or any portion of this Website used in accordance with the license granted herein. Except where a notice of copyright references a Third Party, the following copyright notice must be used when crediting UCAR and the COMET Program as the source of all or any portion of this Website:
            </p>
            <p className="mt-2 text-sm text-gray-500">
            "The source of this material is the COMET® Website at http://meted.ucar.edu/ of the University Corporation for Atmospheric Research (UCAR), sponsored in part through cooperative agreement(s) with the National Oceanic and Atmospheric Administration (NOAA), U.S. Department of Commerce (DOC). ©1997-{currentYear} University Corporation for Atmospheric Research. All Rights Reserved."
            </p>
            <p className="mt-2 text-sm text-gray-500">
            User shall ensure that any credits and/or copyright notices associated with any image or contained in any other part of this Website shall remain intact and unaltered and shall be affixed to any use or copy of all or any such part of this Website.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            The names UCAR/COMET may not be used in any advertising or publicity to endorse or promote any products or commercial entity unless specific written permission is obtained from UCAR. The user also understands that, unless otherwise agreed to in writing by UCAR, UCAR is not obligated to provide support, consulting, training, or assistance of any kind whatsoever with regard to the use of the content operation and/or performance of this Website.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            THE CONTENT ON THIS WEBSITE IS PROVIDED BY UCAR "AS IS" AND UCAR EXPRESSLY DISCLAIMS THE APPLICABILITY OF THE UNIFORM COMPUTER INFORMATION TRANSACTIONS ACT (UCITA), AND ANY OTHER EXPRESS OR IMPLIED WARRANTIES, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF NONINFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. IN NO EVENT SHALL UCAR BE LIABLE FOR ANY DAMAGES OF ANY NATURE ARISING OUT OF THE USE OF THIS SITE OR UCAR'S EXERCISE OF ITS RIGHTS UNDER THESE TERMS OF USE. UCAR SHALL NOT BE LIABLE FOR ANY SPECIAL, INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES OR ANY LOSS OR DAMAGES WHATSOEVER, INCLUDING, BUT NOT LIMITED TO, CLAIMS ASSOCIATED WITH THE LOSS OF DATA OR PROFITS, WHICH MAY RESULT FROM AN ACTION IN CONTRACT, TORT OR IN EQUITY THAT ARISES OUT OF OR IN CONNECTION WITH THE ACCESS, USE, CONTENT, PERFORMANCE OF OR RELIANCE ON THIS WEBSITE, ANY LINKED WEBSITE OR ANY LINKS CONTAINED IN ANY LINKED WEBSITE.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            This Website contains links to Websites that do not belong to UCAR or its affiliates ("third-party sites"). Links to these third-party sites will allow the user to leave UCAR's Website. Any third-party site is outside the domain of and is not under the control of UCAR. UCAR is providing the link only as a convenience. UCAR is not responsible for the content or use of any third-party site or any linked site contained within the third-party site, or any changes or updates thereto. No sponsorship, approval or endorsement of any product, service or information provided by the third-party site, the content of the site, or the site itself is intended or implied by UCAR. UCAR is not affiliated with any owners of trademarks or logos that may be used to link to any third-party site.
            </p>
            <p className="mt-2 text-sm text-gray-500">
            The laws of the State of Colorado and the United States of America, without regard to principles of conflict of laws, will govern these Terms of Use and any dispute that might arise between the user and UCAR. The user shall comply with all laws of the United States of America, including any applicable U.S. export control laws and regulations regarding the use of any or all parts of this Website.
            </p>
          </div>
        </div>
        
        <div className="group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 hidden">
          <div className="mt-8">
            <h3 className="text-base font-semibold text-gray-900">
              <p className="flex w-full items-start justify-between text-left text-gray-900">
                <span aria-hidden="true" className="absolute inset-0" />
                NOAA Cooperative Agreement Numbers  
              </p>
            </h3>
          </div>
          <dl className="grid grid-cols-2 gap-x-4 gap-y-1 max-w-md p-4 my-8">
            <dt className="text-sm mb-4 font-medium text-gray-900"><strong>Agreement Number</strong></dt>
            <dd className="text-sm mb-4 text-gray-900"><strong>Fiscal Year</strong></dd>
            <dt className="text-sm font-medium text-gray-500">NA16NWS4670042</dt>
            <dd className="text-sm text-gray-900">2016-2025</dd>
            <dt className="text-sm font-medium text-gray-500">NA11NWS4670004</dt>
            <dd className="text-sm text-gray-900">2011-2016</dd>
            <dt className="text-sm font-medium text-gray-500">NA06NWS4670013</dt>
            <dd className="text-sm text-gray-900">2007-2011</dd>
            <dt className="text-sm font-medium text-gray-500">NA17WD2383</dt>
            <dd className="text-sm text-gray-900">2001-2006</dd>
            <dt className="text-sm font-medium text-gray-500">NA97WD0082</dt>
            <dd className="text-sm text-gray-900">1998-2001</dd>
            <dt className="text-sm font-medium text-gray-500">NA67WD0097</dt>
            <dd className="text-sm text-gray-900">1995-1998</dd>
            <dt className="text-sm font-medium text-gray-500">NA37WD0018-01</dt>
            <dd className="text-sm text-gray-900">1993-1995</dd>
          </dl>
          </div>*/}
        </div>
        </div>
        <Footer />
      </>
    )
  };